module.exports = __webpack_public_path__ + "assets/img/url.852f8408.svg";